import { FONT_SIZES } from "@/theme/theme/fonts"

export const ICON_SIZES = {
  $2xl: 24,
  $3xl: 28,
  $4xl: 32,
  $lg: FONT_SIZES.$lg,
  $md: FONT_SIZES.$md,
  $sm: FONT_SIZES.$sm,
  $xl: FONT_SIZES.$xl,
} as const
